<template>
  <div class="column">
    <div class="card">
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <p class="title is-4">{{ api.API }}</p>
            <p class="subtitle is-6">{{ api.Category }}</p>
          </div>
        </div>
        <div class="content">
          <p>{{ api.Description }}</p>
        </div>
      </div>
      <div class="card-footer">
        <div class="content">
          <nav class="level is-mobile">
            <div class="card-footer-item">
              <a :href="api.Link" target="_blank" class="level-item">
                <span class="icon is-small">
                  <i class="fas fa-link" aria-hidden="true"></i>
                </span>
              </a>
            </div>
            <div class="card-footer-item">
              <div class="level-left">
                <b-tooltip
                  label="API Key Required"
                  v-if="api.Auth !== ''"
                  class="level-item"
                  position="is-bottom"
                  animated
                >
                  <a>
                    <span class="icon is-small">
                      <i class="fas fa-key" aria-hidden="true"></i>
                    </span>
                  </a>
                </b-tooltip>
                <b-tooltip
                  class="level-item"
                  :label="api.HTTPS ? 'HTTPS' : 'HTTP'"
                  position="is-bottom"
                  animated
                >
                  <a>
                    <span class="icon is-small">
                      <i
                        class="fas"
                        :class="{ 'fa-lock': api.HTTPS, 'fa-unlock': !api.HTTPS }"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </a>
                </b-tooltip>
                <b-tooltip
                  label="CORS"
                  v-if="api.Cors ==='yes'"
                  class="level-item"
                  position="is-bottom"
                  animated
                >
                  <a>
                    <span class="icon is-small">
                      <i class="fas fa-poo" aria-hidden="true"></i>
                    </span>
                  </a>
                </b-tooltip>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    api: {
      type: Object,
      required: true,
    },
  },
};
</script>
